import React from 'react';
import Grid from '@mui/material/Grid2';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';

import type { RequestProps } from '../../models';

interface CandidateProps {
	candidate: RequestProps['candidate'];
	requestExtraInfo: RequestProps['extraInfo'];
}

export const Candidate = ({ candidate, requestExtraInfo }: CandidateProps) => {
	return (
		<Card variant="outlined">
			<CardHeader title="Candidate Details" sx={{ color: 'grey.600' }} />
			<CardContent>
				<Grid container spacing={2}>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							First Name
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate.firstname}
						</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							Last Name
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate.lastname}
						</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							Phone
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate.phone}
						</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							Email
						</Typography>
						<Typography variant="body1" gutterBottom sx={{ wordBreak: 'break-word' }}>
							{candidate.email}
						</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							Postcode
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate.addrPostcode}
						</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							State
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate.addrState}
						</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							Employer
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate.employer}
						</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							Role
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate.jobRole}
						</Typography>
					</Grid>
					{requestExtraInfo && (
						<Grid size={{ xs: 12 }}>
							<Typography variant="subtitle1" gutterBottom>
								What are the physical demand of the role?
							</Typography>
							<Typography variant="body1" gutterBottom>
								{requestExtraInfo}
							</Typography>
						</Grid>
					)}
				</Grid>
			</CardContent>
		</Card>
	);
};
